var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#icon-liveIcon-28e4d';
                    var viewUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#view-icon-liveIcon-28e4d';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };